import Interieur from "./Interieur";
import TuerFluegel from "./TuerFluegel";
import FullHeightDragable from "./FullHeightDragable";

export default class Tuer extends FullHeightDragable {

    // persistent (UserLayer) ------------------------------------------

    // transient (CompiledLayer) ---------------------------------------

    fluegel: ?TuerFluegel[] = [];
    isClosed = true;

    imosGriffHoehe = 0;

    frontBox = new THREE.Box3();

    constructor(type,element) {
        super(type,element);
    }

    getElementBox(element) {
        return element.unverdeckt.box;
    }

    get frontSize() {
        return this.frontBox.getSize();
    }

    get hasFronts() {
        return true;
    }

    getFrontOffset() {
        const aufschlagend = APP.settings.getFloat('aussenwand_vorsprung')==0.0;
        return aufschlagend ? APP.settings.getFloat('brett_staerke') : 0;
    }

    // beide, links, rechts
    getSide() {
        return this.product.Art.split(':')[0];
    }

    // standard, spiegel, glas
    getMaterial() {
        return this.product.Art.split(':')[1];
    }

    get isShallow() {
        return true;
    }

    canOverlay(other: Interieur) {
        return other === this || !other.hasFronts;
    }

    compileFront() {
        if (!this.schrank) {
            return;
        }

        const lazyTuerfluegel = APP.model.lazyPool(this, 'fluegel', () => new TuerFluegel(this));
        if (this.getSide() == 'beide') {
            const links = lazyTuerfluegel.next();
            links.side = 'links';
            const rechts = lazyTuerfluegel.next();
            rechts.side = 'rechts';
        } else {
            const fluegel = lazyTuerfluegel.next();
            fluegel.side = this.getSide();
        }
        lazyTuerfluegel.cleanup();

        if (this.element && !this.boden.bottom) {
            APP.model.maybeThrowCompileError(this,"Tür ohne Böden!", "Tür ohne Böden!");
        }

        this.fluegel.forEach(f => f.compileFront());
        this.imosGriffHoehe = this.fluegel[0].griff
            ? this.fluegel[0].griff.position.y - this.fluegel[0].front.box.min.y
            : 0;

        this.frontBox.makeEmpty();
        this.fluegel.forEach(f => this.frontBox.union(f.front.box));
    }

    showClosed(close, time) {
        if (close === this.isClosed) return;
        this.isClosed = close;
        this.fluegel.forEach((f, i) => f.showClosed(close, time));
        this.object3d.setChangeable(close);
    }

    fromJSON(json) {
        super.fromJSON(json);
        this.isDropped = true;
        return this;
    }

    toJSON() {
        const json = super.toJSON();
        json.frontBox = this.frontBox;
        json.frontSize = this.frontBox.getSize();
        json.imosgriffhoehe = this.imosGriffHoehe;
        json.eckTuerOhneGriff = this.fluegel[0].ecktuerOhneGriff();
        return json;
    }

    setFromProduct(product) {
        this.product = product;
        this.fluegel = [];
        this.compileFront();
        APP.model.setDirty();
    }

    acceptElement(element) {
        if (element.isEckElement) {
            if (this.fluegel.length === 1) {
                const isLeftSchrank = element.schrank === APP.arrangement.schraenke[0];
                const isLeftFluegel = this.fluegel[0].side === "links";
                if (isLeftSchrank && !isLeftFluegel) return false;
                if (!isLeftSchrank && isLeftFluegel) return false;
            } else {
                return false;
            }
        }
        return super.acceptElement(element) && element.getNumberOfParentElements()===0;
    }

    canTopBeSlopedInElement(element) {
        const side = this.getSide();
        if (side==='beide') {
            return false;
        }
        const sl = element.slopeTopLeft;
        const sr = element.slopeTopRight;
        const e = 0.01;
        return (side === 'links' && sl > sr + e) || (side === 'rechts' && sl + e < sr);
    }

    _validate() {
        if (!this.isDropped) {
            return;
        }
        if (this.size.y<APP.settings.getMinValue('tuer_hoehe')) {
            APP.model.maybeThrowCompileError(this,'compileError', 'dialogInteriorMinHeight', this.product.Name, APP.settings.getMinValue('tuer_hoehe'));
        }

        super._validate();
    }

    get flaechenMass() {
        return this.frontBox.getSize();
    }

    iterate(iterator) {
        iterator(this);
        this.fluegel.forEach(x=>x.iterate(iterator));
    }

}
